"use client";

import { Skeleton } from "@/components/ui/skeleton";

export function AgentListItemSkeleton() {
  return (
    <article className="relative overflow-hidden bg-card rounded-2xl p-5 flex flex-col gap-4 ring-1 ring-black/[0.08] shadow-[0_6px_24px_rgba(16,24,40,0.06)]">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-[var(--venturu-green)] via-[var(--venturu-blue)] to-[var(--venturu-amber)] opacity-60" />
      <div className="flex items-start gap-3">
        <Skeleton className="size-14 rounded-full shrink-0" />
        <div className="flex-1 flex flex-col gap-1.5">
          <Skeleton className="h-5 w-32" />
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-3 w-20" />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-2">
        <Skeleton className="h-14 rounded-lg" />
        <Skeleton className="h-14 rounded-lg" />
      </div>

      <Skeleton className="h-4 w-3/4" />
      <Skeleton className="h-3 w-1/3" />
    </article>
  );
}

AgentListItemSkeleton.displayName = "AgentListItemSkeleton";
